var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPyqSearchLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 210,
    viewBox: "0 0 360 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_323_9988)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180.501,
    cy: 203.122,
    r: 175.88,
    fill: "#192732"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.502,
    cy: 203.117,
    r: 117.57,
    fill: "#263B4D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.501,
    cy: 203.12,
    r: 82.0775,
    fill: "#334F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.093 74.2429C199.398 74.3619 214.951 90.1079 214.832 109.412C214.713 128.717 198.967 144.27 179.662 144.151C160.358 144.032 144.805 128.286 144.925 108.981C145.044 89.6768 160.789 74.1239 180.093 74.2429ZM179.704 137.248C195.197 137.344 207.834 124.862 207.93 109.369C208.025 93.8767 195.544 81.2395 180.051 81.1441C164.558 81.0486 151.922 93.5301 151.826 109.023C151.73 124.516 164.212 137.153 179.704 137.248Z",
    fill: "white",
    stroke: "#92A1FF",
    strokeWidth: 0.691918,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.106 72.239C199.411 72.358 214.964 88.104 214.844 107.408C214.724 126.713 198.979 142.266 179.675 142.146C160.37 142.027 144.817 126.281 144.936 106.977C145.057 87.6729 160.802 72.1199 180.106 72.239ZM179.718 135.245C195.21 135.341 207.847 122.859 207.943 107.366C208.038 91.8735 195.557 79.237 180.064 79.1408C164.571 79.0454 151.935 91.5276 151.839 107.02C151.743 122.512 164.225 135.149 179.718 135.245Z",
    fill: "white",
    stroke: "#92A1FF",
    strokeWidth: 0.691918,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.015 174.079L181.483 174.107C182.586 174.114 183.484 173.225 183.491 172.123L183.659 144.946C183.666 143.844 182.778 142.945 181.675 142.938L177.207 142.91C176.104 142.903 175.205 143.792 175.199 144.894L175.031 172.071C175.025 173.173 175.913 174.072 177.015 174.079Z",
    fill: "white",
    stroke: "#92A1FF",
    strokeWidth: 0.691918,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.932 224.392L182.323 224.43C184.732 224.444 186.696 222.503 186.711 220.095L187.042 166.419C187.054 164.537 185.536 163.001 183.654 162.989L175.359 162.938C173.476 162.926 171.94 164.443 171.928 166.326L171.598 220.005C171.583 222.413 173.523 224.377 175.932 224.392Z",
    fill: "#92A1FF",
    stroke: "#92A1FF",
    strokeWidth: 0.691918,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.867,
    cy: 108.366,
    rx: 27.5704,
    ry: 26.6197,
    fill: "#E1EBFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.275,
    cy: 94.423,
    rx: 6.02113,
    ry: 5.70423,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.979,
    cy: 104.563,
    rx: 2.85211,
    ry: 2.53521,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.198,
    cy: 64.6358,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.747,
    cy: 198.366,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.269,
    cy: 175.55,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.101,
    cy: 157.167,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.269,
    cy: 116.605,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.325,
    cy: 20.9014,
    r: 1.90141,
    fill: "#BDCBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.79,
    cy: 44.3545,
    r: 1.90141,
    fill: "#BDCBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_9988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 210,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyqSearchLogoDark);
export default __webpack_public_path__ + "static/media/pyqSearchLogoDark.7b4b4607c0e89ab798416d5af3fdfc1d.svg";
export { ForwardRef as ReactComponent };